import { Box, Typography } from "@mui/material";
import colors from "../../../Constants/colors";

export const EmptyState = ({ text }: { text: string }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 180,
      opacity: 0.8,
    }}
  >
    <img
      src="/pdf_book.png"
      alt="placeholder"
      style={{ width: 96, height: 96, marginBottom: 12 }}
    />
    <Typography
      sx={{
        fontSize: "1rem",
        textAlign: "center",
        color: colors.gray600,
      }}
    >
      {text}
    </Typography>
  </Box>
);
